import { Box } from "@mui/material";
import { gridFilteredDescendantRowCountSelector, GridRowCountProps, useGridApiContext, useGridSelector } from "@mui/x-data-grid-premium";

const CustomFooterRowCount = (props: GridRowCountProps) => {
  const { visibleRowCount: topLevelRowCount } = props;
  const apiRef = useGridApiContext();
  const descendantRowCount = useGridSelector(apiRef, gridFilteredDescendantRowCountSelector);

  return (
    <Box sx={{ mx: 2 }}>
      {descendantRowCount} row{descendantRowCount > 1 ? "s" : ""} in {topLevelRowCount} group
      {topLevelRowCount > 1 ? "s" : ""}
    </Box>
  );
};

export default CustomFooterRowCount;
